export default __webpack_public_path__ + "static/b-card-eyebrow-label-dd32972f7f7ea926e0c1d1bbad3a9483.jpg";